export default "__VITE_PUBLIC_ASSET__c15bd3d9__"